<template>
  <div class="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "App",
  data() {
    return {

    };
  },
  methods: {
   
  },
  mounted() {
  },
  beforeDestroy() {
  },
};
</script>

<style lang="less" scoped>
.app {
  margin: 0 auto;
}
</style>
